// extracted by mini-css-extract-plugin
export var textInput = "_jo-0";